import React from 'react';
import PropTypes from 'prop-types';
import { Card, Image, Divider, Icon } from 'semantic-ui-react';
import { commaFormatted } from '../../utils/helpers/formatting';

const extraStyle = {
  color: '#c71f7e',
};

const textCentered = {
  textAlign: 'center',
};

const Account = ({
  id,
  name,
  username,
  profile_picture_url: profilePictureUrl,
  followers_count: followersCount,
  onClick,
}) => (
  <Card style={textCentered} onClick={() => onClick(id)}>
    <Card.Content>
      <Image src={profilePictureUrl} size="small" className="circular" />
      <Divider hidden />
      <Card.Header>{name}</Card.Header>
      <Card.Meta>
        <span>@{username}</span>
      </Card.Meta>
    </Card.Content>
    <Card.Content extra>
      <a style={extraStyle}>
        <Icon name="user" />
        {commaFormatted(followersCount)} followers
      </a>
    </Card.Content>
  </Card>
);

Account.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  profile_picture_url: PropTypes.string.isRequired,
  followers_count: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Account;



/** WEBPACK FOOTER **
 ** ./src/components/token-generation-card/index.js
 **/